import React from 'react'
import Bounce from "react-reveal"
import Slide from "react-reveal"
import Flip from "react-reveal"
import Rotate from "react-reveal"
import Zoom from "react-reveal"
import Roll from "react-reveal"
import Fade from "react-reveal"

import Macbook from '../components/Macbook'
import { StyledFeature } from './Feature.style'
import { DriverItems, IconItems, LogItems, LogItems1, LogItems2 } from './Feature.constant'
import "../assets/style/feature.css"

import VideoImg from "../../../assets/images/feature.mp4"

import SmartPhone from "../assets/icons/SmartPhone"
import Clock from "../assets/icons/Clock"
import Tablet from "../assets/icons/Tablet"
import Locate from "../../../assets/icons/Locate"
import Connect from "../../../assets/icons/Connect"
import Download from "../../../assets/icons/Download"
import Window from "../assets/icons/Window"
import Time from '../../../assets/icons/Time'
import Car from '../assets/icons/Car'
import Cubic from '../assets/icons/Cubic'
import Check from '../assets/icons/Check'
import Warning from '../assets/icons/Warning'
import Steering from '../assets/icons/Steering'
import Coin from '../assets/icons/Coin'
import Personal from '../assets/icons/Personal'
import Burger from '../assets/icons/Burger'
import Calendar from '../assets/icons/Calendar'
import Screen from '../../../assets/icons/Screen'
import Pencil from '../assets/icons/Pencil'

import Samsung from "../assets/images/Samsung.png"
import Samsung1 from "../assets/images/Samsung1.png"
import Samsung2 from "../assets/images/Samsung2.png"
import Samsung3 from "../assets/images/Samsung3.png"
import Samsung4 from "../assets/images/Samsung4.png"
import Samsung5 from "../assets/images/Samsung5.png"
import Samsung6 from "../assets/images/Samsung6.png"
import Macbook1 from "../assets/images/Macbook1.png"
import Macbook2 from '../assets/images/Macbook2.png'
import Macbook3 from '../assets/images/Macbook3.png'
import Macbook4 from '../assets/images/Macbook4.png'




export default function Feature() {
  return (
    <StyledFeature>
      <header className='feature-header'>
        <div className='shadow'></div>
        <video className='feature-video' src={VideoImg} autoPlay loop muted ></video>
        <div className='container'>
          <div className='feature-main'>
            <h1>Features</h1>
            <p>The most easy-to-use ELD device and application</p>
          </div>
        </div>
      </header>
      {/* 
      <div className='navbar-wrapper'>
        <Navbar />
      </div> */}

      <section className='section-one'>
        <div className='container'>
          <div className='tree'>
            <div className='tree-left'>
              {IconItems.map((i) => (
                i.id % 2 === 1 && (
                  <Bounce left>
                    <div className='tree-item' key={i.id}>
                      <div className='tree-wrapper'>
                        {i.icon}
                        <div className='border'></div>
                        <div>
                          <h4>{i.title}</h4>
                          <p>{i.text}</p>
                        </div>
                      </div>
                      <div className='line'></div>
                    </div>
                  </Bounce>)
              ))}
            </div>
            <div className='tree-center'>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
              <div className='circle'></div>
            </div>
            <div className='tree-right'>
              {IconItems.map((i) => (
                i.id % 2 === 0 && (
                  <Bounce right>
                    <div className='tree-item' key={i.id}>
                      <div className='line'></div>
                      <div className='tree-wrapper'>
                        {i.icon}
                        <div className='border'></div>
                        <div>
                          <h4>{i.title}</h4>
                          <p>{i.text}</p>
                        </div>
                      </div>

                    </div>
                  </Bounce>
                )
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className='section-two'>
        <div className='container'>
          <div className='eld'>
            <div className='redline'><span></span>ELD Components</div>
            <div className='eld-cards'>
              <Slide left>
                <div className='card'>
                  <Tablet />
                  <h3>Logging Device</h3>
                  <p>Simply plug Electronic Logging
                    Device into a vehicleECM port
                    and startrecordingdriving hoursand milesautomatically</p>
                </div>
              </Slide>
              <Slide bottom>
                <div className='card'>
                  <Clock />
                  <h3>Logbook App</h3>
                  <p>Logbook app connects to
                    Electronic Logging Device via
                    bluetooth and displays recorded
                    driving time to a driver</p>
                </div>
              </Slide>
              <Slide right>
                <div className='card'>
                  <SmartPhone />
                  <h3>Tablet/Smartphone</h3>
                  <p>ELD & App work great with most
                    tablets and smartphones. Use yourown or purchase devices and data
                    plans from us.</p>
                </div>
              </Slide>

            </div>
            <div className='redline'><span></span>Install & Connect ELD</div>
            <p>ELDs are installed within minutes</p>
          </div>


        </div>
      </section>

      <section className='section-three'>
        <div className='shadow'></div>
        <div className='container'>
          <div className='install'>
            <div className='install-item'>
              <Locate />
              <div>
                <h2>Locate ECM (diagnostic) port</h2>
                <p>Locate ECM (diagnostic) port inside of your vehicle. Look for 9-pin or 6-pin circular
                  ports in heavy duty vehicles. Look for OBDII port in light/medium duty vehicles.</p>
              </div>
            </div>
            <div className='install-item'>
              <Download />
              <div>
                <h2>Install ELD</h2>
                <p>Simply plug the provided cable into a vehicle ECM (diagnostic) and attach the other
                  end to the ELD device. The dual fastener is provided for dash mounting.</p>
              </div>
            </div>
            <div className='install-item'>
              <Window />
              <div>
                <h2>Log into ELD Logbook App</h2>
                <p>Log in to ELD Logbook App on your tablet/smartphone with a username and password
                  created during a sign up process or provided by a fleet manager.</p>
              </div>
            </div>
            <div className='install-item'>
              <Connect />
              <div>
                <h2>Connect ELD</h2>
                <p>Select a vehicle from a list of available vehicles and your device will attempt to
                  connect to ELD via Bluetooth. Green Bluetooth indicator at the top right corner
                  means you are ready to start using ELD.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='section-four'>
        <div className='container'>
          <div className='redline'><span></span>Driving with ELD </div>
          <div className='driving'>
            <div className='driving-left'>
              <Flip left>
                <img src={Samsung} alt="samsung" />
              </Flip>
            </div>
            <div className='driving-right'>
              <div className='driving-list'>
                <div className='driving-item'>
                  <Time />
                  <p>Once ELD connected, your driving time will be captured automatically.</p>
                </div>
                <div className='driving-item'>
                  <Car />
                  <p>Once your vehicle is moving at 5 mph or more, your duty status is switched to Driving.</p>
                </div>
                <div className='driving-item'>
                  <Cubic />
                  <p>Your logs and others features are not available while in Driving mode due to safety reasons.</p>
                </div>
                <div className='driving-item'>
                  <Check />
                  <p>Once your vehicle is stopped, you may change your duty status by tapping on the
                    status circle. The app will remind you to make a selection in 5 minutes. If no
                    selection is made, your duty status will be switched to On Duty.</p>
                </div>
              </div>

              <div className='driving-card'>
                <Flip top>
                  <div className='card'>
                    <Time />
                    <h3>Hours</h3>
                    <p>Available driving hours, required
                      breaks, on-duty limits and required
                      off-duty time are calculated
                      automatically</p>
                  </div>
                </Flip>
                <Flip top>
                  <div className='card'>
                    <Warning />
                    <h3>Warnings</h3>
                    <p>Visual notifications and sound
                      warnings help you to avoid hours of
                      service violations and stay
                      compliant</p>
                  </div>
                </Flip>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='section-five'>
        <div className='container'>
          <div className='status-top'>
            <div className='redline'><span></span>Duty Status</div>
            <p>Set duty status with just two-clicks. Status is updated automatically when driving starts or
              stops, Easy-to-use interface allows drivers to spend less time doing paperwork and more time
              driving. ELD simplifies training and prevents log errors.</p>
          </div>
        </div>
        <div className='status'>
          <div className='shadow'></div>
          <div className='container'>
            <div className='status-main'>
              <div className='status-left'>
                <div className='status-item'>
                  <Steering />
                  <div>
                    <h3>Current Status</h3>
                    <p>Current duty status is
                      always displayed on
                      Status page inside of
                      status circle along with
                      available or reset hours</p>
                  </div>
                </div>
                <div className='status-item'>
                  <Coin />
                  <div>
                    <h3>Current Status</h3>
                    <p>Tap the status circle,
                      select your current
                      status, add a note if
                      necessary (i.e. pre-trip
                      inspection) and press
                      “Update” button.</p>
                  </div>
                </div>
                <div className='status-item'>
                  <Personal />
                  <div>
                    <h3>Personal/Yard</h3>
                    <p>Personal Use Off-duty and
                      Yard Move On-Duty
                      statuses must be
                      configured and allowed by
                      a fleet manager.</p>
                  </div>
                </div>
              </div>
              <div className='status-right'>
                <Rotate top left><img src={Samsung1} alt="samsung" className='samsung1' /></Rotate>
                <Rotate top left> <img src={Samsung1} alt="samsung" className='samsung2' /></Rotate>
              </div>
            </div>
          </div>
        </div>
        <div className='status-next container'>
          <Rotate top left><img src={Samsung1} alt="samsung" className='samsung1' /></Rotate>
          <Rotate top left> <img src={Samsung1} alt="samsung" className='samsung2' /></Rotate>
        </div>
      </section>

      <section className='section-six'>
        <div className='logs'>
          <div className='container'>
            <div className='redline'><span></span>Logs</div>
            <p>Managing logs has never been easier</p>
          </div>
          <div className='log-main'>
            <div className='shadow'></div>
            <div className='container'>
              <div className='log'>
                <Zoom left>
                  <div className='log-left'>
                    <img className='samsung1' alt='samsung' src={Samsung2} />
                    <img className='samsung2' alt='samsung' src={Samsung2} />
                    <img className='samsung3' alt='samsung' src={Samsung2} />
                  </div>
                </Zoom>
                <div className='log-right'>
                  {LogItems.map((item) => (
                    <div className='log-item' key={item.id}>
                      {item.icon}
                      <div>
                        <h3>{item.title}</h3>
                        <p>{item.text}</p>
                      </div>
                    </div>))}
                </div>
              </div>
            </div>
          </div>
          <Bounce left>
            <div className='log-next container'>
              <img className='samsung1' alt='samsung' src={Samsung2} />
              <img className='samsung2' alt='samsung' src={Samsung2} />
              <img className='samsung3' alt='samsung' src={Samsung2} />
            </div>
          </Bounce>
        </div>
      </section>

      <section className='section-seven'>
        <div className='container'>
          <div className='dvir'>
            <div className='redline'><span></span>DVIRs</div>
            <p>Paper-free DVIRs save time for drivers</p>
            <div className='dvir-next'>
              <Zoom right>
                <img className='samsung1' alt='samsung' src={Samsung3} />
                <img className='samsung2' alt='samsung' src={Samsung3} />
                <img className='samsung3' alt='samsung' src={Samsung3} />
              </Zoom>
            </div>
            <div className='dvir-main'>
              <div className='dvir-list'>
                <div className='dvir-item'>
                  <Time />
                  <div>
                    <h3>Add DVIR </h3>
                    <p>Tap “+” to add pre-trip or post-trip inspection report</p>
                  </div>
                </div>
                <div className='dvir-item'>
                  <Burger />
                  <div>
                    <h3>Defects </h3>
                    <p>Select defects (if any) from the list and sign DVIR</p>
                  </div>
                </div>
                <div className='dvir-item'>
                  <Calendar />
                  <div>
                    <h3>Correct Defects</h3>
                    <p>Notify mechanic if defects need to be corrected</p>
                  </div>
                </div>
              </div>
              <div className='dvir-img'>
                <Zoom left>
                  <img className='samsung1' alt='samsung' src={Samsung3} />
                  <img className='samsung2' alt='samsung' src={Samsung3} />
                  <img className='samsung3' alt='samsung' src={Samsung3} />
                </Zoom>
              </div>
              <div className='dvir-list'>
                <div className='dvir-item'>
                  <Screen />
                  <div>
                    <h3>Review last DVIR</h3>
                    <p>Tap on DVIR to review and to confirm the issues have been resolved</p>
                  </div>
                </div>
                <div className='dvir-item'>
                  <Pencil />
                  <div>
                    <h3>DVIRs History</h3>
                    <p>Review past DVIRs to prevents compliance errors</p>
                  </div>
                </div>
                <div className='dvir-item'>
                  <Check />
                  <div>
                    <h3>Edit DVIR</h3>
                    <p>Tap “…” button to edit DVIR and to fix any errors</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='section-eight'>
        <div className='container'>
          <div className='easy'>
            <div className='redline'><span></span>Easy to Use & to Navigate</div>
            <p>Paper-free DVIRs save time for drivers</p>
            <div className='easy-main'>
              <div className='easy-item'>
                <Slide left>
                  <img src={Samsung4} alt="samsung" />
                </Slide>
                <h2>Easy-to-Navigate
                  & Simple Menu</h2>
              </div>
              <div className='easy-item'>
                <Slide top>
                  <img src={Samsung5} alt="samsung" />
                </Slide>
                <h2>Tap “Start Inspection”
                  for DOT Mode</h2>
              </div>
              <div className='easy-item'>
                <Slide right>
                  <img src={Samsung6} alt="samsung" />
                </Slide>
                <h2>View HOS Rules
                  and Exceptions</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='section-nine'>
        <div className='container'>
          <div className='dashboard'>
            <div className='redline'><span></span>Compliance Dashboard</div>
            <p>Paper-free DVIRs save time for drivers</p>
            <div className='dashboard-main'>
              <Roll top>
                <img src={Macbook1} alt="Macbook" className='macbook' />
              </Roll>
              <Fade left cascade>
                <div className='dashboard-card'>
                  <div className='card'>
                    <Tablet />
                    <h3>Current Status</h3>
                    <p>View currents statuses and
                      locations of your drivers. Click
                      on a driver to see details.</p>
                  </div>
                  <div className='card'>
                    <Clock />
                    <h3>Real-Time Hours</h3>
                    <p>View real-time hours to avoid
                      violations and regulatory fines</p>
                  </div>
                  <div className='card'>
                    <SmartPhone />
                    <h3>Violations</h3>
                    <p>Monitor violations in real time
                      and mitigate compliance risks</p>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section className='section-ten'>
        <Macbook
          text={"Everything about the driver in one place"}
          img={Macbook2}
          list={DriverItems}
          children={<div className='redline'><span></span>Driver Details</div>}
        />
        <Macbook
          text={"Make sure your drivers stay compliant and productive"}
          img={Macbook3}
          list={LogItems1}
          children={<div className='redline'><span></span>Logs</div>}
          side="right"
        />

        <Macbook
          text={"Make sure your drivers stay compliant and productive"}
          img={Macbook4}
          list={LogItems2}
          children={<div className='redline'><span></span>Logs</div>}
        />

      </section>

    </StyledFeature>
  )
}
